"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ejustice_controls_shared_module_1 = require("../../shared/ejustice-controls-shared.module");
var router_1 = require("@angular/router");
var forms_1 = require("@angular/forms");
var pipes_module_1 = require("../../shared/pipes/pipes.module");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var material_1 = require("@angular/material");
var idm_portfolio_control_1 = require("@synisys/idm-portfolio-control");
var pending_action_cards_component_1 = require("./cards/pending-action-cards.component");
var pending_action_portfolio_component_1 = require("./portfolio/pending-action-portfolio.component");
var pending_action_helper_service_1 = require("./service/pending-action-helper.service");
var pending_action_dashboard_component_1 = require("./pending-action-dashboard.component");
var base_portfolio_helper_service_1 = require("../summary-pages/common/service/base-portfolio-helper.service");
var pending_action_portfolio_helper_service_1 = require("./service/pending-action-portfolio-helper.service");
var dynamic_component_loader_module_1 = require("../dynamic-component-loader/dynamic-component-loader.module");
var routes = [
    {
        path: '',
        component: pending_action_dashboard_component_1.PendingActionDashboardComponent,
    },
    {
        path: 'pending/:pendingItemType/:categoryId',
        component: pending_action_portfolio_component_1.PendingActionPortfolioComponent,
    }
];
var PendingActionDashboardModule = /** @class */ (function () {
    function PendingActionDashboardModule() {
    }
    PendingActionDashboardModule = __decorate([
        core_1.NgModule({
            imports: [
                forms_1.FormsModule,
                forms_1.ReactiveFormsModule,
                ejustice_controls_shared_module_1.EjusticeControlsSharedModule,
                pipes_module_1.PipesModule,
                idm_ng_controls_1.ControlsModule,
                material_1.MatNativeDateModule,
                router_1.RouterModule,
                idm_portfolio_control_1.PortfolioModule,
                dynamic_component_loader_module_1.DynamicComponentLoaderModule,
                router_1.RouterModule.forChild(routes),
            ],
            declarations: [
                pending_action_cards_component_1.PendingActionCardsComponent,
                pending_action_portfolio_component_1.PendingActionPortfolioComponent,
                pending_action_dashboard_component_1.PendingActionDashboardComponent,
            ],
            entryComponents: [],
            exports: [
                pending_action_dashboard_component_1.PendingActionDashboardComponent
            ],
            providers: [
                pending_action_helper_service_1.PendingActionHelperService,
                base_portfolio_helper_service_1.BasePortfolioHelperService,
                pending_action_portfolio_helper_service_1.PendingActionPortfolioHelperService,
            ]
        })
    ], PendingActionDashboardModule);
    return PendingActionDashboardModule;
}());
exports.PendingActionDashboardModule = PendingActionDashboardModule;
//# sourceMappingURL=pending-action-dashboard.module.js.map